import Vue from 'vue'
import Vuex from 'vuex'
import users from "./modules/users";
import devices from "./modules/devices";
import invoice from "./modules/invoice";
import payment from "./modules/payment";
import items from "./modules/items";
import expenseitems from "./modules/expenseitems";
import notes from "./modules/notes";
import dispatch from "./modules/dispatch";
import customers from "./modules/customers";
import stockadjustments from "./modules/stockadjustments";
import inbounds from "./modules/inbounds";
import intransfers from "./modules/intransfers";
import orders from "./modules/orders";
import collections from "./modules/collections";
import warehouse from "./modules/warehouse";
import purchaseorder from "./modules/purchaseorder";
import apiService from "../service/apiService";
import passwordprotection from "@/store/modules/passwordprotection";
import products from "@/store/modules/products";
import claims from "@/store/modules/claims";
import branch_targets from "@/store/modules/branch_targets";
import branch_credits from "@/store/modules/branch_credits";
import branch_tasks from "@/store/modules/branch_tasks";
import franchisees from "@/store/modules/franchisees";
import branches from "@/store/modules/branches";
import locations from "@/store/modules/locations";
import franchiseeBills from "@/store/modules/franchiseeBills";

Vue.use(Vuex)
const store = new Vuex.Store({
    strict: false,
    state: {
        user: {},


    },
    getters: {
        AuthenticatedUser: (state) => state.user,
    },
    mutations: {
        setUser: (state, user) => state.user = user,
    },
    actions: {
        async login({commit}, credentials) {
            const user = (await apiService.post('/login', credentials)).data;

            if(user.status_code==200){
                localStorage.setItem('token', user.user.token);
                localStorage.setItem('user', JSON.stringify(user.user));
                commit('setUser', user)
            }

            return user
        },

        async processLogoutManual({commit}) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            commit('setUser', {})

        },
    },

    modules: {

        users,
        devices,
        invoice,
        items,
        expenseitems,
        customers,
        stockadjustments,
        inbounds,
        payment,
        notes,
        dispatch,
        orders,
        collections,
        warehouse,
        purchaseorder,
        passwordprotection,
        products,
        intransfers,
        claims,
        branch_targets,
        branch_credits,
        branch_tasks,
        franchisees,
        branches,
        locations,
        franchiseeBills

    },

})

export default store
